<template>
  <div id="app">
    <a-config-provider :locale="locale">
      <router-view />
    </a-config-provider>
  </div>
</template>
<script>
import { checkAccount } from '@/api/user';
import { Modal } from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';

moment.locale('zh-cn');
export default {
  data() {
    return {
      locale: zhCN,
    };
  },
  created() {
    this.checkCount();
  },
  methods: {
    async checkCount() {
      const that = this;
      const { data: { arrearage, list } } = await checkAccount();
      const h = this.$createElement;
      const content = h('div', {}, list.map((item) => h('a', {
        domProps: {
          innerHTML: `${item.name}(${item.account})`,
        },
        on: {
          click: () => {
            Modal.destroyAll();
            that.$router.push(`/company/recharge/${item.id}`);
          },
        },
      })));
      if (arrearage) {
        this.$warning({
          title: '系统已欠费(点击充值)',
          content,
        });
      }
    },
  },
  mounted() {
    const that = this;
    window.onresize = () => (() => {
      const h = document.body.clientHeight;
      console.log(h);
      that.$store.commit('SET_H', h);
    })();
  },
};
</script>
<style lang="less">
html,body{
  padding: 0;
  margin: 0;
  height: 100%;
  width: 100%;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
  text-align: left;
}
.ant-layout{
  height: 100%;
}
#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
